import { Component, HostListener } from '@angular/core';
import { AuthService } from './auth/services/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { ToasterService } from './shared/services/toaster.service';
import { GetterSetterService } from './shared/services/getter-setter.service';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { TokenService } from './shared/services/token.service';

declare const gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'SOVOS-E-Invoice';
  showHead = false;

  idleTime = 30 * 60 * 1000; // 15 minutes in milliseconds
  timeoutId: any;

  //@HostListener("window:beforeunload",["$event"])
  // clearSessiionStorage(event){
  //     sessionStorage.clear();
  // }

  constructor(
    private auth: AuthService,
    private router: Router,
    private toaster: ToasterService,
    private getSet: GetterSetterService,
    private tokenService: TokenService
  ) {

    if(environment.GA_TRACKING_ID){

      this.addGAScript();

      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {

          /** START : Code to Track Page View  */
          gtag('event', 'page_view', {
            page_path: event.urlAfterRedirects
          })
        });
      }

    // this.showheader();
    this.auth.getLoginIndicator().subscribe((value) => {
      if (value === 0) {
        this.showHead = false;
      } else if (value === 1) {
        this.showHead = false;
      } else if (value === 2) {
        this.showHead = true;
        // Reset idle timeout on any user activity
        document.addEventListener('mousemove', this.resetIdleTimeout);
        document.addEventListener('keypress', this.resetIdleTimeout);

        this.startTimerAgain();
      }
    });
    this.getSet.setOnyxLite(this.getSet.getOnyxLiteFromSession() === 'true' ? true : false)
    }

    /** Add Google Analytics Script Dynamically */
    addGAScript() {
      let gtagScript: HTMLScriptElement = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.GA_TRACKING_ID;
      document.head.prepend(gtagScript);
      /** Disable automatic page view hit to fix duplicate page view count  **/
      gtag('config', environment.GA_TRACKING_ID, { send_page_view: false });
  }

  resetIdleTimeout = () => {
    clearTimeout(this.timeoutId);
    this.startTimerAgain();
  }

  startTimerAgain() {
     this.timeoutId = setTimeout(() => {
       // Logout logic here
       console.log('Logging out due to inactivity');
       if (this.tokenService.destroy()) {
         this.auth.setLoginIndicator(0);
         window.open(this.tokenService.getUumUrl(), '_self');
       }

     }, this.idleTime);
  }
}


